export const GENERATION_STEPS = [
  {
    key: 'initializing',
    stepNumber: 1,
    label: 'Setting Up',
    description: 'Preparing your game workspace',
  },
  {
    key: 'categories',
    stepNumber: 2,
    label: 'Designing Categories',
    description: 'Creating unique category themes',
  },
  {
    key: 'ideas',
    stepNumber: 3,
    label: 'Brainstorming',
    description: 'Generating creative question concepts',
  },
  {
    key: 'questions',
    stepNumber: 4,
    label: 'Writing Questions',
    getDescription: (categoryCount) =>
      categoryCount > 0
        ? `Crafting questions across ${categoryCount} categories`
        : 'Crafting questions across all categories',
  },
  {
    key: 'validation',
    stepNumber: 5,
    label: 'Quality Check',
    getDescription: (categoryCount) =>
      categoryCount > 0
        ? `Reviewing every question for accuracy across ${categoryCount} categories`
        : 'Reviewing every question for accuracy',
  },
  {
    key: 'finalJeopardy',
    stepNumber: 6,
    label: 'The Finale',
    description: 'Creating the grand finale',
  },
  {
    key: 'assembly',
    stepNumber: 7,
    label: 'Final Assembly',
    description: 'Building your game board',
  },
];

export const STEP_COUNT = GENERATION_STEPS.length;

export const getStepByPhase = (phaseKey) =>
  GENERATION_STEPS.find((s) => s.key === phaseKey) || GENERATION_STEPS[0];

export const getStepDescription = (step, categoryCount) => {
  if (step.getDescription) {
    return step.getDescription(categoryCount);
  }
  return step.description;
};
